
























































import Vue from 'vue'
import ToolbarSave from '@/components/icons/toolbar-save.vue'
import ToolbarRefresh from '@/components/icons/toolbar-refresh.vue'

import { GetSetting, PatchSetting } from '@/api/sync-server'

import 'splitpanes/dist/splitpanes.css'
import { SyncServerSetting } from '../../../types/sync'
export default Vue.extend({
  components: { ToolbarSave, ToolbarRefresh },
  data() {
    return {
      setting: {} as SyncServerSetting,
    }
  },
  methods: {
    async getSetting() {
      this.setting = await GetSetting()
    },

    async patchSetting() {
      await PatchSetting(this.setting)
    },

    async onToolbarRefresh() {
      await this.getSetting()
    },

    async onToolbarSave() {
      await this.patchSetting()
      await this.getSetting()
    },
  },

  async created() {
    await this.getSetting()
  },
})
